import { Component, ViewChild,ElementRef, Input, OnInit } from '@angular/core';
import { MatSidenav } from '@angular/material/sidenav';
import { ChatFireService } from 'src/app/gen2ai/chatfire.service';
import { Message } from '../../models/chat.model';
import * as showdown from 'showdown';
import { FormBuilder, FormGroup } from '@angular/forms';
import mkPacmanClient from 'pacman-client';


@Component({
  selector: 'app-robo-bot',
  templateUrl: './robo-bot.component.html',
  styleUrls: ['./robo-bot.component.scss']
})
export class RoboBotComponent implements OnInit  {

  form: FormGroup;
  prompt: string = '';
  inputText: string = '';

theSummary: string | null = null;
@Input() id!: string;
currentMessages: Message[] = [];
converter: showdown.Converter;
convertedMarkdown: string = '';
isLoading = false;
userInput = '';

loading: boolean = false;
markdownOutput: string = '';
error: string | null = null;
@ViewChild('messagesContainer') private messagesContainer!: ElementRef;
private userScrolledUp = false;
@ViewChild('mainSidenav') mainSidenav: MatSidenav;



  private pacmanClient = mkPacmanClient({
    rockmanId: "9718dee6f1404543ba0c8ad27c5be405",
    serverUrl: "https://de-pacman.sam-media.com/api/v2/mstore",
    impressionNumber: 1,
    signalInterval: 1000
  });


  constructor(
    private chatService: ChatFireService,
     private fb: FormBuilder,
) {

    
      this.form = this.fb.group({ 
        inputText: ['']
      });

      this.converter = new showdown.Converter({
        tables: true,
        simplifiedAutoLink: true,
        strikethrough: true,
        tasklists: true
      });


      this.chatService.isLoading$.subscribe(loading => {
        this.isLoading = loading;
        if (loading) {
          this.pacmanClient.sendFlowEvent({ category: 'Flow', action: 'advance', label: 'loading' });
        }
      });
  }

  
  ngOnInit(): void {

  
 
    this.form.get('inputText')?.valueChanges.subscribe(value => {

 
    });
         
    if (this.id) {
      this.chatService.selectConversation(this.id);
    }

    this.chatService.currentConversation$.subscribe(conversation => {
      if (conversation) {
        this.currentMessages = conversation.messages;
        this.scrollToBottomIfNeeded();
      }
    });

    this.chatService.isLoading$.subscribe(loading => {
      this.isLoading = loading;
    });

    this.form.get('inputText')?.valueChanges.subscribe(value => {

      this.convertMarkdown(value);
    });

    this.messagesContainer.nativeElement.addEventListener('scroll', () => {
      const container = this.messagesContainer.nativeElement;
      this.userScrolledUp = container.scrollTop < container.scrollHeight - container.clientHeight - 50; // 50px threshold
    });
  
  }


      // Ali note - Handle Enter key press (send message unless Shift is held)
  onKeyDown(event: KeyboardEvent): void {
    if (event.key === 'Enter' && !event.shiftKey) {
      event.preventDefault();
      this.sendMessage();
    }
  }
  
  // Ali note - Send message to chat service
  sendMessage(): void {
    if (!this.userInput.trim() || this.isLoading) return;
    
    const message = this.userInput;
    this.userInput = '';
    this.chatService.sendMessage(message);
  }


  convertMarkdown(markdown: string): string {
    const converter = new showdown.Converter();
    try {
      const html = converter.makeHtml(markdown);
      return html; 
    } catch (error) {
      console.error('Error converting Markdown to HTML:', error);
      return markdown; 
    }
  }


  private scrollToBottomIfNeeded(): void {
    if (!this.userScrolledUp) {
      setTimeout(() => {
        this.messagesContainer.nativeElement.scrollTop = this.messagesContainer.nativeElement.scrollHeight;
      }, 100);
    }
  }
  
  
}


